
export default function HowItWorks() {
  const steps = [
    {
      number: '1',
      icon: 'ri-message-3-line',
      title: 'Text or WhatsApp Us',
      description:
        'Send us your vehicle type, location, and what service you need. We\'ll reply quickly with a custom quote.',
      action: 'Start Here',
      link: 'sms:+17863272644',
    },
    {
      number: '2',
      icon: 'ri-calendar-check-line',
      title: 'We Schedule & Confirm',
      description:
        'Pick a time that works for you. We\'ll confirm the appointment and arrive at your location with all our equipment.',
      action: null,
      link: null,
    },
    {
      number: '3',
      icon: 'ri-car-washing-line',
      title: 'We Detail Your Car',
      description:
        'Sit back and relax while we transform your vehicle. We handle everything—you don\'t lift a finger.',
      action: null,
      link: null,
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-black via-gray-900 to-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-gradient-to-tl from-yellow-500/20 to-transparent"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-yellow-500 uppercase tracking-wider text-sm font-semibold mb-3">
            SIMPLE PROCESS
          </p>
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            How It Works
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Getting your car detailed has never been easier. Three simple steps to a showroom-quality vehicle.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 mb-12">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line (desktop only) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-16 left-1/2 w-full h-0.5 bg-gradient-to-r from-yellow-500/50 to-yellow-500/20 z-0"></div>
              )}

              {/* Step Card */}
              <div className="relative z-10 text-center">
                {/* Number Badge */}
                <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full text-black text-3xl font-bold mb-6 shadow-2xl shadow-yellow-500/40">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="w-16 h-16 bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-6 border-2 border-yellow-500/30">
                  <i className={`${step.icon} text-yellow-500 text-2xl`}></i>
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold text-white mb-4">{step.title}</h3>
                <p className="text-gray-400 leading-relaxed mb-6 max-w-sm mx-auto">
                  {step.description}
                </p>

                {/* Action Button */}
                {step.action && step.link && (
                  <a
                    href={step.link}
                    className="inline-flex items-center gap-2 bg-yellow-500 text-black px-6 py-3 rounded-full font-bold hover:bg-yellow-400 transition-all whitespace-nowrap cursor-pointer shadow-lg shadow-yellow-500/30"
                  >
                    <i className="ri-arrow-right-line"></i>
                    {step.action}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center">
          <div className="inline-block bg-gradient-to-br from-gray-900 to-black border-2 border-yellow-500/40 rounded-2xl p-8 max-w-2xl">
            <h3 className="text-2xl font-bold text-white mb-3">Ready to Get Started?</h3>
            <p className="text-gray-300 mb-6">
              Text us now with your vehicle details and location. We'll send you a quote within minutes.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="sms:+17863272644"
                className="bg-yellow-500 text-black px-8 py-3.5 rounded-full font-bold hover:bg-yellow-400 transition-all inline-flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer shadow-xl shadow-yellow-500/40"
              >
                <i className="ri-message-3-line text-xl"></i>
                Text (786) 327-2644
              </a>
              <a
                href="https://wa.me/17863272644"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-600 text-white px-8 py-3.5 rounded-full font-bold hover:bg-green-500 transition-all inline-flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer shadow-xl shadow-green-600/40"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
